import { useAdminContext } from './AdminContext';
import CsvTab from './tabs/CsvTab';
import ImagesTab from './tabs/ImagesTab';
import SpritesheetsTab from './tabs/SpritesheetsTab';
import SettingsTab from './tabs/SettingsTab';
import UserFlairTab from './tabs/UserFlairTab';
import GrantUserFlairTab from './tabs/GrantUserFlairTab';
import SchedulerTab from './tabs/SchedulerTab';
import AwardsTab from './tabs/AwardsTab';

/**
 * Renders the settings tab content (CSV, Images, Spritesheets, Settings, User Flair, Grant User Flair, Scheduler, Awards).
 * Uses AdminContext for state and handlers.
 */
export default function SettingsTabs() {
  const { activeSettingsTab } = useAdminContext();

  if (!activeSettingsTab) return null;

  return (
    <>
      {activeSettingsTab === 'csv' && <CsvTab />}
      {activeSettingsTab === 'images' && <ImagesTab />}
      {activeSettingsTab === 'spritesheets' && <SpritesheetsTab />}
      {activeSettingsTab === 'settings' && <SettingsTab />}
      {activeSettingsTab === 'user-flair' && <UserFlairTab />}
      {activeSettingsTab === 'grant-user-flair' && <GrantUserFlairTab />}
      {activeSettingsTab === 'scheduler' && <SchedulerTab />}
      {activeSettingsTab === 'awards' && <AwardsTab />}
    </>
  );
}
